<template>
  <div class="row border-bottom border-2 border-gray-200 py-3">
    <h2> {{ $t('payslip.title.pension') }} </h2>
    <PayslipPensionForm
        v-for="(pension, index) in formData.pension_employers"
        :key="pension.id + index"
        :id="'payslip-employee-pension-'+index"
        :index="index"
        :pension="pension"
        :currency="currency"
        @delete-row="removePensionRow"
        :base-salary="base_salary"
        :pension-type="pensionTypesEnums.EMPLOYER_PENSION"
        :parent-id="parentId"
    />
    <div class="col-12 d-flex justify-content-end align-items-end float-end my-5">
      <div class="justify-content-end align-items-end float-end my-1">
        <a class="btn btn-primary" @click.prevent="addPensionRow">
          {{ $t('payslip.new.addPension') }}
        </a>
      </div>
    </div>
  </div>
  <div class="row py-3">
    <h2> {{ $t('payslip.title.taxes') }} </h2>
    <PayslipTaxForm
        v-for="(tax, index) in formData.taxe_employers"
        :key="tax.id + index"
        :id="'payslip-employee-tax-'+index"
        :index="index"
        :tax="tax"
        :currency="currency"
        @delete-row="removeTaxRow"
        :base-salary="base_salary"
        :tax-type="payrollTaxStatusEnums.EMPLOYER_TAXE"
        :parent-id="parentId"
    />
    <div class="col-12 d-flex justify-content-end align-items-end float-end my-5">
      <div class="justify-content-end align-items-end float-end my-1">
        <a class="btn btn-primary" @click.prevent="addTaxRow">
          {{ $t('payslip.new.addTax') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>

import { defineProps, ref } from "vue";
import PayslipPensionForm from "@/Modules/RH/components/Payslip/PayslipPensionForm.vue";
import PayslipTaxForm from "@/Modules/RH/components/Payslip/PayslipTaxForm.vue";
import {usePayslipEnums} from "@/Modules/RH/composables/payslipEnums";

const props = defineProps({
  parentId: String,
  base_salary: '',
  currency: {type: String, default: 'CFA'},
  data: {
    type: Object,
    default: () => ({
      base_salary: '',
      pension_employers: [
        {
          id: '',
          value: 0,
          edited: false
        }
      ],
      taxe_employers: [
        {
          id: '',
          value: 0,
          edited: false
        }
      ],
    })
  }
})
const { pensionTypesEnums, payrollTaxStatusEnums } = usePayslipEnums()

const formData = ref(props.data)

const addPensionRow = () => {
  formData.value.pension_employers.push({
    id: '',
    value: 0,
    edited: false
  })
}
const removePensionRow = (index) => {
  if (formData.value.pension_employers.length > 0) {
    const [pensionToDelete] = formData.value.pension_employers.splice(index, 1)
  }
}

const addTaxRow = () => {
  formData.value.taxe_employers.push({
    id: '',
    value: 0,
    edited: false
  })
}
const removeTaxRow = (index) => {
  if (formData.value.taxe_employers.length > 0) {
    const [taxToDelete] = formData.value.taxe_employers.splice(index, 1)
  }
}
</script>

<style scoped>

</style>